import { motion, AnimatePresence } from "framer-motion";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export default function Home() {
  const slides = [
    {
      image: "/2026/BBND5219.JPG",
      heading: "Annual Janhit Mini Marathon 2026",
      paragraph:
        "Run of Youth, Strength of Society. Join thousands in our mission to promote health, unity, and community empowerment.",
    },
    {
      image: "/2026/Marathon.png",
      heading: "Run For A Cause & Create Impact",
      paragraph:
        "Every step empowers lives and inspires change. Register now and run with us for a stronger future.",
    },
  ];

  const settings = {
    dots: false,
    infinite: true,
    speed: 1200,
    autoplay: true,
    autoplaySpeed: 5000,
    fade: true,
    arrows: false,
    pauseOnHover: false,
  };

  return (
    <div className="relative w-full h-[75vh] min-h-[480px] sm:h-[82vh] md:h-[88vh] max-h-[850px] overflow-hidden">
      <Slider {...settings}>
        {slides.map((slide, index) => (
          <div key={index}>
            <AnimatePresence mode="wait">
              <motion.div
                key={slide.image}
                initial={{ opacity: 0, scale: 1.04 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.98 }}
                transition={{
                  duration: 1.2,
                  ease: [0.25, 0.1, 0.25, 1],
                }}
                className="w-full h-[75vh] min-h-[480px] sm:h-[82vh] md:h-[88vh] max-h-[850px] bg-cover bg-center relative flex items-center"
                style={{
                  backgroundImage: `url(${slide.image})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
              >
                {/* Responsive Contrast Gradient Overlay */}
                <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/60 to-black/35 sm:from-black/75 sm:via-black/50 sm:to-black/25"></div>

                {/* Hero Text & CTA Container */}
                <motion.div
                  initial={{ opacity: 0, y: 30 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.8, delay: 0.3 }}
                  className="relative z-10 w-full px-5 sm:px-8 md:px-14 lg:px-20 max-w-xl sm:max-w-2xl md:max-w-3xl"
                >
                  <motion.h1
                    initial={{ opacity: 0, y: 15 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8, delay: 0.4 }}
                    className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-bold font-body text-white mb-3 sm:mb-4 leading-snug drop-shadow-md"
                  >
                    {slide.heading}
                  </motion.h1>

                  <motion.p
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8, delay: 0.6 }}
                    className="text-sm sm:text-base md:text-lg lg:text-xl font-body text-gray-100 leading-relaxed max-w-xl drop-shadow"
                  >
                    {slide.paragraph}
                  </motion.p>

                  <motion.div
                    initial={{ opacity: 0, y: 15 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8, delay: 0.8 }}
                    className="mt-6 sm:mt-8"
                  >
                    <a
                      href="https://forms.gle/L5LzaPyM5tRgtQ1i9"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center justify-center gap-2 bg-brandRed hover:bg-red-700 text-white font-semibold text-sm sm:text-base md:text-lg py-3 sm:py-3.5 px-6 sm:px-8 rounded-full shadow-xl transition-all duration-300 hover:scale-105 active:scale-95"
                    >
                      <span>Register Now</span>
                      <svg
                        className="w-4 h-4 sm:w-5 sm:h-5 ml-1"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2.5"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M14 5l7 7m0 0l-7 7m7-7H3"
                        />
                      </svg>
                    </a>
                  </motion.div>
                </motion.div>
              </motion.div>
            </AnimatePresence>
          </div>
        ))}
      </Slider>
    </div>
  );
}
